import NodeInactive from './node-inactive';

export default NodeInactive;
